'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SwellOverwrite = {};
var $dom = {};

var cacheDom = function cacheDom() {
  $dom.referralOverwrite = $('.referral-widget-mobile');
  $dom.swellOverwriteModal = $('[data-remodal-id=swellOverwriteModal]');
  $dom.swellOverwriteModalClose = $('.js-swell-overwrite-modal-close');
  $dom.swellRemodalCode = $('.swell-remodal-code');
};

var bindUIActions = function bindUIActions() {
  $dom.referralOverwrite.on('click', function () {
    $(this).removeClass('is-active');
    $dom.swellOverwriteModal.remodal().open();
  });

  $dom.swellOverwriteModalClose.on('click', function () {
    $dom.referralOverwrite.addClass('is-active');
  });

  $(document).on('closing', '.swell-overwrite-modal.remodal', function (e) {
    $dom.referralOverwrite.addClass('is-active');
  });

  $(document).on('opening', '.swell-overwrite-modal.remodal', function (e) {
    $dom.referralOverwrite.removeClass('is-active');
  });
};

SwellOverwrite.addReferralCodeToModal = function () {
  var swellRefferalCode = localStorage.getItem('swell-referred-customer-coupon-code');

  if (swellRefferalCode != undefined && swellRefferalCode != null) {
    swellRefferalCode = swellRefferalCode.trim();
  }
  if (swellRefferalCode != '' && swellRefferalCode != undefined && swellRefferalCode != null) {
    $dom.swellRemodalCode.html(swellRefferalCode);
    $dom.referralOverwrite.addClass('is-active');
  }
};

SwellOverwrite.init = function () {
  cacheDom();
  bindUIActions();
};

window.SwellOverwrite = SwellOverwrite;
exports.default = SwellOverwrite;